// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const stoneworks = defineModel({
  id: "stoneworks",
  batchId: "future",
  name: "Stoneworks",
  tags: ["building","stoneworks","low-poly","age-of-mcp","future"],
  summary: "Cuts and dresses stone into blocks, slabs and columns for masonry.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 1,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(1.85, 0.14, 1.85), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(1.85, 0.14, 1.85), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.5, 0.45, 1.1), color: "#8d8678", position: [0, 0.365, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.45, 0.1), color: "#6c665a", position: [-0.75, 0.365, -0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.45, 0.1), color: "#6c665a", position: [0.75, 0.365, -0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.45, 0.1), color: "#6c665a", position: [-0.75, 0.365, 0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.45, 0.1), color: "#6c665a", position: [0.75, 0.365, 0.55] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.9, 4), color: "#6b4a26", position: [-0.775, 0.45, -0.775] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.9, 4), color: "#6b4a26", position: [0.775, 0.45, -0.775] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.9, 4), color: "#6b4a26", position: [-0.775, 0.45, 0.775] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.9, 4), color: "#6b4a26", position: [0.775, 0.45, 0.775] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(1.85, 0.14, 1.85), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.5, 0.82, 1.1), color: "#8d8678", position: [0, 0.55, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.82, 0.1), color: "#6c665a", position: [-0.75, 0.55, -0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.82, 0.1), color: "#6c665a", position: [0.75, 0.55, -0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.82, 0.1), color: "#6c665a", position: [-0.75, 0.55, 0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.82, 0.1), color: "#6c665a", position: [0.75, 0.55, 0.55] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.3, 4), color: "#6b4a26", position: [-0.775, 0.65, -0.775] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.3, 4), color: "#6b4a26", position: [0.775, 0.65, -0.775] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.3, 4), color: "#6b4a26", position: [-0.775, 0.65, 0.775] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.3, 4), color: "#6b4a26", position: [0.775, 0.65, 0.775] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(1.85, 0.14, 1.85), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.5, 0.82, 1.1), color: "#8d8678", position: [0, 0.55, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.82, 0.1), color: "#6c665a", position: [-0.75, 0.55, -0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.82, 0.1), color: "#6c665a", position: [0.75, 0.55, -0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.82, 0.1), color: "#6c665a", position: [-0.75, 0.55, 0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.82, 0.1), color: "#6c665a", position: [0.75, 0.55, 0.55] },
      { geometry: new THREE.BoxGeometry(1.72, 0.07, 0.778679), color: "#7a4a36", position: [0, 1.15, 0.305], rotation: [0.557124, 0, 0] },
      { geometry: new THREE.BoxGeometry(1.72, 0.07, 0.778679), color: "#7a4a36", position: [0, 1.15, -0.305], rotation: [-0.557124, 0, 0] },
      { geometry: new THREE.BoxGeometry(1.74, 0.085, 0.085), color: "#5a3526", position: [0, 1.34, 0] },
      { geometry: new THREE.BoxGeometry(0.34, 0.52, 0.05), color: "#5a4530", position: [0, 0.4, 0.56] },
      { geometry: new THREE.BoxGeometry(0.42, 0.24, 0.34), color: "#9a958a", position: [0.6, 0.26, 0.46] },
      { geometry: new THREE.CylinderGeometry(0.03, 0.03, 0.62, 6), color: "#8a5f33", position: [0.44, 0.45, 0.46] },
      { geometry: new THREE.CylinderGeometry(0.03, 0.03, 0.62, 6), color: "#8a5f33", position: [0.76, 0.45, 0.46] },
      { geometry: new THREE.BoxGeometry(0.4, 0.05, 0.05), color: "#5f3f20", position: [0.6, 0.74, 0.46] },
      { geometry: new THREE.BoxGeometry(0.36, 0.02, 0.03), color: "#5b6166", position: [0.6, 0.44, 0.46] },
      { geometry: new THREE.BoxGeometry(0.26, 0.26, 0.26), color: "#9a958a", position: [-0.62, 0.27, 0.5] },
      { geometry: new THREE.BoxGeometry(0.22, 0.22, 0.22), color: "#8c877c", position: [-0.6, 0.51, 0.5] },
      { geometry: new THREE.BoxGeometry(0.24, 0.24, 0.24), color: "#a09a8e", position: [-0.62, 0.26, 0.18] },
    ] },
  ],
  animations: [],
});
